module.exports = __webpack_public_path__ + "img/SalamActive.6fd5e3c2.svg";